import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { UseFormReturn } from "react-hook-form";

export const useUrlParamValue = (fieldName: string, entityForm: UseFormReturn<any>, currentValue?: any) => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const paramValue = searchParams.get(`[${fieldName}]`);
        
        if (!paramValue) return;
        
        const formValue = entityForm.getValues(fieldName);
        
        // Only set if field is empty or undefined
        if (!formValue && formValue !== currentValue) {
            entityForm.setValue(fieldName, paramValue);
        }
    }, [searchParams, fieldName, entityForm, currentValue]);
};

